export default {"src":"/_next/static/media/teams-active-icon.69417da4.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};